/** Lowercase + strip spaces/hyphens so GOA-2-26-27 and GOA 2 26 27 are the same ID. */
export const normalizeExact = (text) =>
  String(text ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s\-_/]+/g, "")

const isNumericToken = (text) => /^[\d.,]+$/.test(String(text ?? "").trim())

const parseAmount = (text) => {
  const n = Number(String(text ?? "").trim().replace(/,/g, ""))
  return Number.isFinite(n) ? n : null
}

const shipmentSearchFields = (shipment) => [
  shipment.shipment_id,
  shipment.sender_name,
  shipment.sender_contact,
  shipment.sender_email,
  shipment.sender_address,
  shipment.sender_location,
  shipment.receiver_name,
  shipment.receiver_contact,
  shipment.receiver_email,
  shipment.receiver_address,
  shipment.receiver_location,
  shipment.consigner_name,
  shipment.consignee_name,
  shipment.status,
  shipment.balance_amount != null ? String(shipment.balance_amount) : "",
  shipment.total_amount != null ? String(shipment.total_amount) : "",
  shipment.no_of_articles != null ? String(shipment.no_of_articles) : "",
  shipment.mode_of_payment,
  shipment.ml_sheet_id,
]

/**
 * Exact match on any one shipment field.
 * IDs ignore hyphen/space differences. Partial IDs and cross-field token
 * matching (e.g. GOA-2-26-27 hitting GOA-1-26-27) do not match.
 */
export const shipmentMatchesSearch = (shipment, query) => {
  const raw = String(query || "").trim()
  if (!raw) return true

  const qNorm = normalizeExact(raw)
  if (!qNorm) return true

  const qAmount = isNumericToken(raw) ? parseAmount(raw) : null

  return shipmentSearchFields(shipment).some((value) => {
    if (value == null || value === "") return false
    const str = String(value).trim()
    if (!str) return false
    if (normalizeExact(str) === qNorm) return true
    if (qAmount != null && isNumericToken(str) && parseAmount(str) === qAmount) {
      return true
    }
    return false
  })
}
